function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M401.65 18.23a62.49 62.49 0 00-88.3 0l-22.1 22.23L55.98 275.6l-.5.5c-.12.13-.12.26-.25.26-.25.37-.62.74-.87 1.12 0 .12-.13.12-.13.25-.25.37-.37.62-.62 1-.12.12-.12.24-.25.37-.12.38-.25.63-.38 1 0 .12-.12.12-.12.25L.66 437.32a12.29 12.29 0 003 12.73 12.56 12.56 0 008.87 3.63c1.35-.02 2.7-.23 4-.63l156.84-52.32c.12 0 .12 0 .25-.12.4-.12.77-.29 1.12-.5.1-.02.19-.06.26-.13.37-.25.87-.5 1.24-.75s.75-.62 1.13-.87c.12-.13.24-.13.24-.25.13-.13.38-.25.5-.5L435.5 140.24a62.48 62.48 0 000-88.3zM169.38 371.38l-86.92-86.9L300 66.93l86.91 86.9zm-99.16-63.8l75.93 75.92-114.02 37.96zm347.66-184.83l-13.24 13.37-86.91-86.92 13.36-13.36a37.46 37.46 0 0152.95 0L418 69.8a37.58 37.58 0 01-.12 52.95zm0 0"
});

var SvgEditpic = function SvgEditpic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "#7D64E1",
    viewBox: "-15 -15 484 484",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEditpic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editpic.c20ecf34.svg";
export { ForwardRef as ReactComponent };